module.exports = __webpack_public_path__ + "static/media/blue-september-prostate-cancer-news.a354129c.jpg";